import React, { useState, useEffect } from "react";
import { BarChart, Bar } from "recharts";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import * as Popover from "@radix-ui/react-popover";
import { MoreVertical } from "lucide-react";
import { PieChart, Pie, Cell} from "recharts";
import { Link } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import { Table, Card } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./Overview.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';
import moment from 'moment';

const chartData = {
  "This Month": [
    {
      name: "Sep 24",
      Salary: 12000,
      Revenue: 27000,
      Commission: 18000,
      Expenses: 30000,
    },
  ],
  "Last Month": [
    {
      name: "Aug 24",
      Salary: 10000,
      Revenue: 20000,
      Commission: 15000,
      Expenses: 28000,
    },
  ],
};

const COLORSSS = {
  Salary: "#0D4796",
  Revenue: "#38BDF8",
  Commission: "#FBDA7A",
  Expenses: "#F85E62",
};

const items = [
  { name: "Salary", color: COLORSSS.Salary },
  { name: "Revenue", color: COLORSSS.Revenue },
  { name: "Commission", color: COLORSSS.Commission },
  { name: "Expenses", color: COLORSSS.Expenses },
];


// Merchant's Information end
const datab = [
  { dept: "VP", Admin: 1, Sales: 1, Marketing: 1, Engineer: 1, CS_TS: 0},
  { dept: "Directors", Admin: 2, Sales: 2, Marketing: 1, Engineer: 2, CS_TS: 1},
  { dept: "Managers", Admin: 3, Sales: 5, Marketing: 2, Engineer: 4, CS_TS: 3},
  { dept: "Sales Rep", Admin: 0, Sales: 10, Marketing: 0, Engineer: 0, CS_TS: 0},
  { dept: "Salespersons", Admin: 0, Sales: 25, Marketing: 0, Engineer: 0, CS_TS: 0},
  { dept: "Staff", Admin: 10, Sales: 15, Marketing: 8, Engineer: 30, CS_TS: 15}
];

const departments = [
  { name: "Admin", VP: 1, Directors: 2, Managers: 3, SalesRep: "-", Salespersons: "-", Staff: 10 },
  { name: "Sales", VP: 1, Directors: 2, Managers: 3, SalesRep: 10, Salespersons: 25, Staff: 15 },
  { name: "Marketing", VP: 1, Directors: 2, Managers: 3, SalesRep: "-", Salespersons: "-", Staff: 8 },
  { name: "Engineer", VP: 1, Directors: 1, Managers: 3, SalesRep: "-", Salespersons: "-", Staff: 30 },
  { name: "CS/TS", VP: 1, Directors: 1, Managers: 3, SalesRep: "-", Salespersons: "-", Staff: 15 },
];

const formatValue = (val) => {
  return val === "-" ? "-" : String(val).padStart(2, "0");
};

const datae = [
  { month: "January", revenue: "$100,000", salary: "$40,000", commission: "$10,000", expenses: "$14,000" },
  { month: "February", revenue: "$20,000", salary: "$40,000", commission: "$10,000", expenses: "$14,000"},
  { month: "March", revenue: "$89,000", salary: "$40,000", commission: "$10,000", expenses: "$14,000"},
  { month: "April", revenue: "$18,000", salary: "$40,000", commission: "$10,000", expenses: "$14,000"},
  { month: "May", revenue: "$50,000", salary: "$40,000", commission: "$10,000", expenses: "$14,000"},
  { month: "June", revenue: "$600,000", salary: "$40,000", commission: "$10,000", expenses: "$14,000"}
];

const datacd = [
  { date: "05/09/2024", event: "Annual Sales", location: "LA", budget: 10000, personInCharge: "John Doe"},
  { date: "05/09/2024", event: "Product Launch", location: "NY", budget: 75000, personInCharge: "Jane Smith"},
  { date: "09/15/2024", event: "Employee Training", location: "IL", budget: 24000, personInCharge: "John Doe"},
  { date: "10/05/2024", event: "Product Launch", location: "NY", budget: 12000, personInCharge: "Emily John"},
  { date: "11/20/2024", event: "Employee Training", location: "IL", budget: 23000, personInCharge: "Jane Smith"},
  { date: "11/20/2024", event: "Annual Sales", location: "CA", budget: 10000, personInCharge: "Emily John"}
]

const data = [
  { date: "02/09/24", income: 4000, subscription: 5000, employee: 1200, others1: 2000, Others2: 1200, SalesCommission: 1800, OtherExpenses: 6000 },
  { date: "03/09/24", income: 3000, subscription: 2500, employee: 2000, others1: 4500, Others2: 5500, SalesCommission: 4500, OtherExpenses: 1100 },
  { date: "04/09/24", income: 2000, subscription: 5000, employee: 3000, others1: 2100, Others2: 2500, SalesCommission: 2300, OtherExpenses: 3500 },
  { date: "05/09/24", income: 5000, subscription: 3000, employee: 3500, others1: 2500, Others2: 3500, SalesCommission: 4800, OtherExpenses: 1200 },
];
const allLines = [
  { key: "income", name: "Income", color: "#6D7EBA" },
  { key: "subscription", name: "Subscription Income", color: "#E49D9F" },
  { key: "employee", name: "Employee Account Income", color: "#4D3EFE" },
  { key: "others1", name: "Others 1", color: "#FFD66B" },
  { key: "Others2", name: "Others 2", color: "#FA906F" },
  { key: "SalesCommission", name: "Sales Commission", color: "#4D40FC" },
  { key: "OtherExpenses", name: "Other Expenses", color: "#3267A1" },
];
// Revenue Information end

const Overview = () => {
  const [loading,setLoading] = useState(false);


const [selectedRangeStartStat, setSelectedRangeStartStat] = useState('');
  const [selectedRangeEndStat, setSelectedRangeEndStat] = useState('');

  const [showCalendarStat, setShowCalendarStat] = useState(false);
  const [selectedRangeStat, setSelectedRangeStat] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);


  const [selectedRangeStartRev, setSelectedRangeStartRev] = useState('');
  const [selectedRangeEndRev, setSelectedRangeEndRev] = useState('');

  const [showCalendarRev, setShowCalendarRev] = useState(false);
  const [selectedRangeRev, setSelectedRangeRev] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);


  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedRange, setSelectedRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const handleSelect = (ranges) => {
    setSelectedRange([ranges.selection]);
  };

  const closeCalendar = () => setShowCalendar(false);

  const [isMobile, setIsMobile] = useState(false);
  const [accordionOpen, setAccordionOpen] = useState(false);
  const [accordionHR, setAccordionHR] = useState(false);
  const [accordionPayment, setAccordionPayment] = useState(false);
  const [accordionStrat, setAccordionStrat] = useState(false);

  const [selected, setSelected] = useState("This Month");

  const [visibleLines, setVisibleLines] = useState(["subscription", "employee", "others1"]);


  const [statistics, setStatistics] = useState({subscribers: 0, quit_subscribers: 0,free_trial:0,customers:0,salesperson:0});

  const [revenueinformation, setRevenueinformation] = useState({total_income: 0, subscription_income: 0,employee_income:0,sales_commission_amount:0,total_commission_payout:0});

  const toggleLine = (key) => {
    setVisibleLines((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const datac = [
    { name: "3 mon", value: 40 },
    { name: "12 mon", value: 30 },
    { name: "6 mon", value: 30 },
  ];

  const COLORS = ["#0D4796", "#C1292D", "#FBDA7A"]; 

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const name = payload[0].name.includes("mon")
      ? payload[0].name.replace("mon", "Months")
      : payload[0].name;
      const value = payload[0].value;

      return (
        <div className="my-custom-tooltip">
          <div className="tooltip-name">{name}</div>
          <div className="tooltip-value">{value}%</div>
        </div>
      );
    }
    return null;
  };

  const renderCustomLegend = () => {
    const items = [
      { name: "3 mon", color: "#0D4796" },
      { name: "6 mon", color: "#FBDA7A" },
      { name: "12 mon", color: "#C1292D" },
    ];
    return (
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px", flexWrap: "wrap" }}>
        {items.map((item) => (
          <div key={item.name} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <div
              style={{
                width: "17px",
                height: "15px",
                backgroundColor: item.color,
                borderRadius: "5px",
              }}
            />
            <span className="monthy">{item.name}</span>
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    document.title = `Overview | bluefaucet`;
    document.getElementById("bodywrap").className = "dashovme";
  
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    API.post('get_home',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setStatistics({
            subscribers:response.data.data.statistics.subscribers,
            quit_subscribers:response.data.data.statistics.quit_subscribers,
            free_trial:response.data.data.statistics.free_trial,
            customers:response.data.data.statistics.customers,
            salesperson:response.data.data.statistics.salesperson,
         });
         setRevenueinformation(
         {
            total_income:response.data.data.revenue_information.total_income,
            subscription_income:response.data.data.revenue_information.subscription_income,
            employee_income:response.data.data.revenue_information.employee_income,
            sales_commission_amount:response.data.data.revenue_information.sales_commission_amount,
            total_commission_payout:response.data.data.revenue_information.total_commission_payout,
         }
        )
      }                  
    }).catch(error => {
       setLoading(false);
       
    });  

    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };
  
    handleResize();
    window.addEventListener("resize", handleResize);
  
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const handleSelectStat = (ranges) => {
    setSelectedRangeStat([ranges.selection]);
    setSelectedRangeStartStat(ranges.selection.startDate);
    setSelectedRangeEndStat(ranges.selection.endDate);
  };
  const closeCalendarStat = () => {
    setShowCalendarStat(false);
    setLoading(true);
    
    var start_date = moment(selectedRangeStat[0].startDate).format('YYYY-MM-DD');
    var end_date = moment(selectedRangeStat[0].endDate).format('YYYY-MM-DD');

    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('statistics_start_date', start_date);
    formData.append('statistics_end_date', end_date);
    if(selectedRangeStartRev!=='' && selectedRangeEndRev!=='')
    {
      var start_date_rev = moment(selectedRangeStartRev).format('YYYY-MM-DD');
      var end_date_rev = moment(selectedRangeEndRev).format('YYYY-MM-DD');
      formData.append('revenue_start_date', start_date_rev);
      formData.append('revenue_end_date', end_date_rev);
    }
    
    API.post('get_home',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setStatistics({
            subscribers:response.data.data.statistics.subscribers,
            quit_subscribers:response.data.data.statistics.quit_subscribers,
            free_trial:response.data.data.statistics.free_trial,
            customers:response.data.data.statistics.customers,
            salesperson:response.data.data.statistics.salesperson,
         });
         setRevenueinformation(
         {
            total_income:response.data.data.revenue_information.total_income,
            subscription_income:response.data.data.revenue_information.subscription_income,
            employee_income:response.data.data.revenue_information.employee_income,
            sales_commission_amount:response.data.data.revenue_information.sales_commission_amount,
            total_commission_payout:response.data.data.revenue_information.total_commission_payout,
         }
        )
      }                  
    }).catch(error => {
       setLoading(false);
    });
  }

  const handleSelectRev = (ranges) => {
    setSelectedRangeRev([ranges.selection]);
    setSelectedRangeStartRev(ranges.selection.startDate);
    setSelectedRangeEndRev(ranges.selection.endDate);
  };
  const closeCalendarRev = () => {
    setShowCalendarRev(false);
    setLoading(true);
    
    var start_date = moment(selectedRangeRev[0].startDate).format('YYYY-MM-DD');
    var end_date = moment(selectedRangeRev[0].endDate).format('YYYY-MM-DD');

    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('revenue_start_date', start_date);
      formData.append('revenue_end_date', end_date);
    
    if(selectedRangeStartStat!=='' && selectedRangeEndStat!=='')
    {
      var start_date_stat = moment(selectedRangeStartStat).format('YYYY-MM-DD');
      var end_date_stat = moment(selectedRangeEndStat).format('YYYY-MM-DD');
      formData.append('statistics_start_date', start_date_stat);
      formData.append('statistics_end_date', end_date_stat);
    }
    
    API.post('get_home',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setStatistics({
            subscribers:response.data.data.statistics.subscribers,
            quit_subscribers:response.data.data.statistics.quit_subscribers,
            free_trial:response.data.data.statistics.free_trial,
            customers:response.data.data.statistics.customers,
            salesperson:response.data.data.statistics.salesperson,
         });
         setRevenueinformation(
         {
            total_income:response.data.data.revenue_information.total_income,
            subscription_income:response.data.data.revenue_information.subscription_income,
            employee_income:response.data.data.revenue_information.employee_income,
            sales_commission_amount:response.data.data.revenue_information.sales_commission_amount,
            total_commission_payout:response.data.data.revenue_information.total_commission_payout,
         }
        )
      }                  
    }).catch(error => {
       setLoading(false);
    });
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <div className="col-12 d-flex align-items-center justify-content-between mb-3 firsty">
                      <h5>Statistics</h5>
                      <div>
                        {/* Trigger Button */}
                        <button
                          className="btn canu"
                          onClick={() => setShowCalendarStat(true)}
                        >
                          {selectedRangeStat[0].startDate.toLocaleDateString()} -{" "}
                          {selectedRangeStat[0].endDate.toLocaleDateString()}{" "}
                          <i className="bi bi-calendar"></i>
                        </button>

                        {/* Calendar Popup */}
                        {showCalendarStat && (
                          <div
                            className="calendar-popup-overlay"
                            onClick={closeCalendarStat}
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: "rgba(0,0,0,0.3)",
                              zIndex: 9999,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="calendar-popup-content"
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                backgroundColor: "#fff",
                                padding: "20px",
                                borderRadius: "8px",
                                maxWidth: "855px",
                                width: "100%",
                                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                              }}
                            >
                              <DateRangePicker
                                onChange={handleSelectStat}
                                showSelectionPreview={true}
                                moveRangeOnFirstSelection={false}
                                months={2}
                                ranges={selectedRangeStat}
                                direction="horizontal"
                                locale={enUS}
                              />
                              <div className="text-end mt-3">
                                <button className="btn done-btn" onClick={closeCalendarStat}>
                                  Done
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row d-flex align-items-center justify-content-start justify-content-xl-between boxe mb-4">
                    
                      <div
                          key={1}
                          className={`custom-box-item `}>
                          <Link className="text-start text-decoration-none" to={`${process.env.REACT_APP_BASE_URL}merchant-overview`}>
                          <div className="card d-flex justify-content-between flex-column">
                            
                            <div className="d-flex align-items-start justify-content-between gap-2">
                              <span>Subscribers</span>
                              <img
                                src={process.env.REACT_APP_BASE_URL + 'assests/images/b-1.png'}
                                alt="Subscribers"
                                className="img-fluid"
                              />
                            </div>
                            <h4>{statistics.subscribers}</h4>
                            
                          </div>
                          </Link>
                        </div>
                        
                        <div
                          key={2}
                          className={`custom-box-item `}>
                          <Link className="text-start text-decoration-none" to={`${process.env.REACT_APP_BASE_URL}merchant-overview`}>
                          <div className="card d-flex justify-content-between flex-column">
                            <div className="d-flex align-items-start justify-content-between gap-2">
                              <span>Quit Subscribers</span>
                              <img
                                src={process.env.REACT_APP_BASE_URL + 'assests/images/b-2.png'}
                                alt="Quit Subscribers"
                                className="img-fluid"
                              />
                            </div>
                            <h4>{statistics.quit_subscribers}</h4>
                          </div>
                          </Link>
                        </div>
                        <div
                          key={3}
                          className={`custom-box-item `}>
                          <Link className="text-start text-decoration-none" to={`${process.env.REACT_APP_BASE_URL}merchant-overview`}>
                          <div className="card d-flex justify-content-between flex-column">
                            <div className="d-flex align-items-start justify-content-between gap-2">
                              <span>Free Trials</span>
                              <img
                                src={process.env.REACT_APP_BASE_URL + 'assests/images/b-3.png'}
                                alt="Free Trials"
                                className="img-fluid"
                              />
                            </div>
                            <h4>{statistics.free_trial}</h4>
                          </div>
                          </Link>
                        </div>
                        <div
                          key={4}
                          className={`custom-box-item `}>
                          <div className="card d-flex justify-content-between flex-column">
                            <div className="d-flex align-items-start justify-content-between gap-2">
                              <span>Customer</span>
                              <img
                                src={process.env.REACT_APP_BASE_URL + 'assests/images/b-4.png'}
                                alt="Customer"
                                className="img-fluid"
                              />
                            </div>
                            <h4>{statistics.customers}</h4>
                          </div>
                        </div>
                        <div
                          key={5}
                          className={`custom-box-item last`}>
                          <div className="card d-flex justify-content-between flex-column">
                            <div className="d-flex align-items-start justify-content-between gap-2">
                              <span>Salespersons</span>
                              <img
                                src={process.env.REACT_APP_BASE_URL + 'assests/images/b-5.png'}
                                alt="Salespersons"
                                className="img-fluid"
                              />
                            </div>
                            <h4>{statistics.salesperson}</h4>
                          </div>
                        </div>
                      
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <div className="col-12 d-flex align-items-center justify-content-between mb-4 firsty"
                      onClick={() => isMobile && setAccordionOpen(!accordionOpen)}
                      style={{ cursor: isMobile ? "pointer" : "default" }}
                    >
                      <h5>Revenue Information</h5>
                      <div className="d-none d-md-block">
                        {/* Trigger Button */}
                        <button
                          className="btn canu"
                          onClick={() => setShowCalendarRev(true)}
                        >
                          {selectedRangeRev[0].startDate.toLocaleDateString()} -{" "}
                          {selectedRangeRev[0].endDate.toLocaleDateString()}{" "}
                          <i className="bi bi-calendar"></i>
                        </button>

                        {/* Calendar Popup */}
                        {showCalendarRev && (
                          <div
                            className="calendar-popup-overlay"
                            onClick={closeCalendarRev}
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: "rgba(0,0,0,0.3)",
                              zIndex: 9999,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="calendar-popup-content"
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                backgroundColor: "#fff",
                                padding: "20px",
                                borderRadius: "8px",
                                maxWidth: "855px",
                                width: "100%",
                                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                              }}
                            >
                              <DateRangePicker
                                onChange={handleSelectRev}
                                showSelectionPreview={true}
                                moveRangeOnFirstSelection={false}
                                months={2}
                                ranges={selectedRangeRev}
                                direction="horizontal"
                                locale={enUS}
                              />
                              <div className="text-end mt-3">
                                <button className="btn done-btn" onClick={closeCalendarRev}>
                                  Done
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      {isMobile && (
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            (accordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                          }
                          alt="Toggle Arrow"
                        />
                      )}
                    </div>

                    {(!isMobile || accordionOpen) && (
                      <div className="row g-3 mb-4">
                        <div className="w-30 text-end d-block d-md-none mb-3">
                        <div>
                        {/* Trigger Button */}
                        <button
                          className="btn canu"
                          onClick={() => setShowCalendar(true)}
                        >
                          {selectedRange[0].startDate.toLocaleDateString()} -{" "}
                          {selectedRange[0].endDate.toLocaleDateString()}{" "}
                          <i className="bi bi-calendar"></i>
                        </button>

                        {/* Calendar Popup */}
                        {showCalendar && (
                          <div
                            className="calendar-popup-overlay"
                            onClick={closeCalendar}
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: "rgba(0,0,0,0.3)",
                              zIndex: 9999,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="calendar-popup-content"
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                backgroundColor: "#fff",
                                padding: "20px",
                                borderRadius: "8px",
                                maxWidth: "855px",
                                width: "100%",
                                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                              }}
                            >
                              <DateRangePicker
                                onChange={handleSelect}
                                showSelectionPreview={true}
                                moveRangeOnFirstSelection={false}
                                months={2}
                                ranges={selectedRange}
                                direction="horizontal"
                                locale={enUS}
                              />
                              <div className="text-end mt-3">
                                <button className="btn done-btn" onClick={closeCalendar}>
                                  Done
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-4 col-xxl-4 thrres">
                          <Card className="h-100">
                            <Card.Title>Revenue Statistics</Card.Title>
                            <div className="table-ro">
                              <Table responsive className="table-no-last-border mb-0">
                                <thead className="table">
                                  <tr className="custom-header">
                                    <th className="lft">Revenue Type</th>
                                    <th className="rft">Revenue</th>
                                  </tr>
                                </thead>
                              </Table>
                              <div style={{ maxHeight: "448px", overflowY: "auto" }}>
                                <Table
                                  responsive
                                  className="table-no-last-border mb-0"
                                >
                                  <tbody>
                                    <tr key={1}>
                                        <td className="lef">Income Amount</td>
                                        <td className="ref">{revenueinformation.total_income}</td>
                                    </tr>
                                    <tr key={2}>
                                        <td className="lef">Subscription Income</td>
                                        <td className="ref">{revenueinformation.subscription_income}</td>
                                    </tr>
                                    <tr key={3}>
                                        <td className="lef">Employee Account Income</td>
                                        <td className="ref">{revenueinformation.employee_income}</td>
                                    </tr>
                                    
                                    <tr key={5}>
                                        <td className="lef">Sales Commission Amount</td>
                                        <td className="ref">{revenueinformation.sales_commission_amount}</td>
                                    </tr>
                                    <tr key={5}>
                                        <td className="lef">Total Sales Commission Payout</td>
                                        <td className="ref">{revenueinformation.total_commission_payout}</td>
                                    </tr>
                                    
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </Card>
                        </div>

                        <div className="col-md-6 col-lg-6 col-xl-4 col-xxl-4 ftres">
                          <div className="card h-100">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h5>Revenue Graph</h5>
                              <Popover.Root>
                                <Popover.Trigger asChild>
                                  <Link className="mb-0">
                                    <MoreVertical size={18} />
                                  </Link>
                                </Popover.Trigger>
                                <Popover.Content className="popover-content">
                                  {allLines.map(({ key, name, color }) => (
                                    <div
                                      key={key}
                                      className="d-flex align-items-center justify-content-between py-2"
                                      onClick={() => toggleLine(key)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div className="d-flex align-items-center gap-2">
                                        <div
                                          className="rounded-circle"
                                          style={{
                                            width: 8,
                                            height: 8,
                                            backgroundColor: color,
                                          }}
                                        ></div>
                                        <div className="heri">{name}</div>
                                      </div>
                                      <input
                                        type="checkbox"
                                        checked={visibleLines.includes(key)}
                                        readOnly
                                        className="form-check-input ms-auto"
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          backgroundImage: visibleLines.includes(key)
                                            ? "url('/assests/images/chekes.png')"
                                            : "none",
                                          backgroundRepeat: "no-repeat",
                                          backgroundPosition: "center",
                                          backgroundSize: "16px",
                                          boxShadow: "none",
                                          border: visibleLines.includes(key)
                                            ? "none"
                                            : "1px solid #858585",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </div>
                                  ))}
                                </Popover.Content>
                              </Popover.Root>
                            </div>

                            <ResponsiveContainer width="100%" height={410}>
                              <LineChart
                                data={data}
                                margin={{ top: 10, right: 10, left: -5, bottom: 10 }}
                              >
                                <XAxis
                                  dataKey="date"
                                  axisLine={false}
                                  tickLine={false}
                                />
                                <YAxis
                                  tickFormatter={(value) => `$ ${value}`}
                                  domain={[0, 6000]}
                                  ticks={[1000, 2000, 3000, 4000, 5000, 6000]}
                                  axisLine={false}
                                  tickLine={false}
                                />
                                <Tooltip
                                  formatter={(value) => `$ ${value}`}
                                  cursor={false}
                                />
                                {allLines.map(({ key, color }) =>
                                  visibleLines.includes(key) ? (
                                    <Line
                                      key={key}
                                      type="natural"
                                      dataKey={key}
                                      stroke={color}
                                      strokeWidth={2}
                                      dot={false}
                                    />
                                  ) : null
                                )}
                              </LineChart>
                            </ResponsiveContainer>
                            <div className="d-flex flex-wrap justify-content-center align-items-center gap-2">
                              {allLines
                                .filter(({ key }) => visibleLines.includes(key))
                                .map(({ key, name, color }) => (
                                  <div
                                    key={key}
                                    className="d-flex align-items-center gap-2"
                                  >
                                    <div
                                      style={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: "50%",
                                        backgroundColor: color,
                                      }}
                                    ></div>
                                    <div className="small">{name}</div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 col-lg-6 col-xl-4 col-xxl-4 sstre">
                          <div className="card h-100">
                            <h4>Payment Plan</h4>
                            <ResponsiveContainer width="100%" height={400}>
                              <PieChart>
                                <Pie
                                  data={datac}
                                  dataKey="value"
                                  nameKey="name"
                                  cx="50%"
                                  cy="50%"
                                  innerRadius={0}
                                  outerRadius="80%"
                                  labelLine={false}
                                >
                                  {datac.map((entry, index) => (
                                    <Cell
                                      key={entry.name}
                                      fill={COLORS[index % COLORS.length]}
                                    />
                                  ))}
                                </Pie>
                                <Tooltip content={<CustomTooltip />} />
                              </PieChart>
                            </ResponsiveContainer>
                            {renderCustomLegend()}
                          </div>
                        </div>
                      </div>
                    )}
                    
                    <div className="row mb-0 mb-md-4">
                      <div className="col-12 d-flex align-items-center justify-content-between mb-4 firsty d-block d-md-none"
                        onClick={() => isMobile && setAccordionHR(!accordionHR)}
                        style={{ cursor: isMobile ? "pointer" : "default" }}
                        >
                        <h5>HR statistics & Employee Setup</h5>
                        {isMobile && (
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              (accordionHR ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                            }
                            alt="Toggle Arrow"
                          />
                        )}
                      </div>
                      {(!isMobile || accordionHR) && (
                        <div className="col-md-6 holisti">
                          <Card className="h-100">
                            <div className="d-flex justify-content-end justify-content-md-between gap-3">
                              <Card.Title className="d-none d-md-block">HR statistics & Employee Setup</Card.Title>
                              <div className="fdf">Total Employees 160</div>
                            </div>
                            <div className="table-ro d-none d-md-block">
                              <div style={{ maxHeight: "380px", overflowY: "auto" }}>
                                <Table
                                  responsive
                                  className="table-no-last-border mb-0"
                                >
                                  <thead className="table">
                                    <tr className="custom-header">
                                      <th className="lft">Dept. & Level</th>
                                      <th>Admin</th>
                                      <th>Sales</th>
                                      <th>Marketing</th>
                                      <th>Engineer</th>
                                      <th>CS/TS</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {datab.map((item, index) => (
                                      <tr key={index}>
                                        <td className="lef">{item.dept}</td>
                                        <td>{item.Admin}</td>
                                        <td>{item.Sales}</td>
                                        <td>{item.Marketing}</td>
                                        <td>{item.Engineer}</td>
                                        <td className="ref">{item.CS_TS}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                            <div className="row gy-3 d-md-none hr-mobile mb-4">
                              {departments.map((dept, idx) => (
                                <div className="col-12" key={idx}>
                                  <Card>
                                    <h6>{dept.name}</h6>
                                    <div className="row">
                                      <div className="col-4">
                                        <h2>VP</h2>
                                        <h3>{formatValue(dept.VP)}</h3>
                                      </div>
                                      <div className="col-4">
                                        <h2>Directors</h2>
                                        <h3>{formatValue(dept.Directors)}</h3>
                                      </div>
                                      <div className="col-4">
                                        <h2>Managers</h2>
                                        <h3>{formatValue(dept.Managers)}</h3>
                                      </div>
                                      <div className="col-4">
                                        <h2>Sales Rep</h2>
                                        <h3>{formatValue(dept.SalesRep)}</h3>
                                      </div>
                                      <div className="col-4">
                                        <h2>Salespersons</h2>
                                        <h3>{formatValue(dept.Salespersons)}</h3>
                                      </div>
                                      <div className="col-4">
                                        <h2>Staff</h2>
                                        <h3>{formatValue(dept.Staff)}</h3>
                                      </div>
                                    </div>
                                  </Card>
                                </div>
                              ))}
                            </div>
                          </Card>
                        </div>
                      )}

                      <div className="col-12 d-flex align-items-center justify-content-between mb-4 firsty d-block d-md-none"
                        onClick={() => isMobile && setAccordionPayment(!accordionPayment)}
                        style={{ cursor: isMobile ? "pointer" : "default" }}
                        >
                        <h5>Marketing Event List</h5>
                        {isMobile && (
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              (accordionPayment ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                            }
                            alt="Toggle Arrow"
                          />
                        )}
                      </div>

                      {(!isMobile || accordionPayment) && (
                        <div className="col-md-6 holisti">
                          <Card className="h-100">
                            <Card.Title className="d-none d-md-block">Marketing Event List</Card.Title>
                            <div className="table-ro mt-2 d-none d-md-block">
                              <div style={{ maxHeight: "380px", overflowY: "auto" }}>
                                <Table
                                  responsive
                                  className="table-no-last-border mb-0"
                                >
                                  <thead className="table">
                                    <tr className="custom-header">
                                      <th className="lft">Date</th>
                                      <th>Event</th>
                                      <th>Loc.</th>
                                      <th>Budget</th>
                                      <th>Person InCharge</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {datacd.map((item, index) => (
                                      <tr key={index}>
                                        <td className="lef">{item.date}</td>
                                        <td>{item.event}</td>
                                        <td>{item.location}</td>
                                        <td>{item.budget}</td>
                                        <td className="ref">{item.personInCharge}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                            <div className="d-md-none mb-3 ev-mobile">
                                {datacd.map((item, index) => (
                                  <div
                                    key={index}
                                    className="col-12 mb-3 main"
                                  >
                                    <div className="d-flex justify-content-between fir mb-2">
                                      <h2>{item.date}</h2>
                                      <h3>{item.personInCharge}</h3>
                                    </div>
                                    <div className="d-flex justify-content-between two">
                                      <h2>{item.event}</h2>
                                      <h3>${item.budget.toLocaleString()}</h3>
                                    </div>
                                    <h4>
                                      {item.location}
                                    </h4>
                                  </div>
                                ))}
                            </div>
                          </Card>
                        </div>
                      )}
                    </div>

                      <div className="col-12 d-flex align-items-center justify-content-between mb-4 firsty d-block d-md-none"
                        onClick={() => isMobile && setAccordionStrat(!accordionStrat)}
                        style={{ cursor: isMobile ? "pointer" : "default" }}
                        >
                        <h5>Accounting Statistics</h5>
                        {isMobile && (
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              (accordionStrat ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                            }
                            alt="Toggle Arrow"
                          />
                        )}
                      </div>
                      {(!isMobile || accordionStrat) && (
                        <div className="row">
                          <div className="col-md-6 col-xl-7 col-xxl-8 holisti">
                            <Card className="h-100">
                              <div className="d-flex justify-content-end justify-content-md-between gap-3">
                                <Card.Title className="d-none d-md-block">Accounting Statistics</Card.Title>
                                <div>
                                  {/* Trigger Button */}
                                  <button
                                    className="btn canu"
                                    onClick={() => setShowCalendar(true)}
                                  >
                                    {selectedRange[0].startDate.toLocaleDateString()} -{" "}
                                    {selectedRange[0].endDate.toLocaleDateString()}{" "}
                                    <i className="bi bi-calendar"></i>
                                  </button>

                                  {/* Calendar Popup */}
                                  {showCalendar && (
                                    <div
                                      className="calendar-popup-overlay"
                                      onClick={closeCalendar}
                                      style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: "rgba(0,0,0,0.3)",
                                        zIndex: 9999,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        className="calendar-popup-content"
                                        onClick={(e) => e.stopPropagation()}
                                        style={{
                                          backgroundColor: "#fff",
                                          padding: "20px",
                                          borderRadius: "8px",
                                          maxWidth: "855px",
                                          width: "100%",
                                          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                                        }}
                                      >
                                        <DateRangePicker
                                          onChange={handleSelect}
                                          showSelectionPreview={true}
                                          moveRangeOnFirstSelection={false}
                                          months={2}
                                          ranges={selectedRange}
                                          direction="horizontal"
                                          locale={enUS}
                                        />
                                        <div className="text-end mt-3">
                                          <button className="btn done-btn" onClick={closeCalendar}>
                                            Done
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="table-ro d-none d-md-block">
                                <div style={{ maxHeight: "380px", overflowY: "auto" }}>
                                  <Table
                                    responsive
                                    className="table-no-last-border mb-0"
                                  >
                                    <thead className="table">
                                      <tr className="custom-header">
                                        <th className="lft">Month</th>
                                        <th>Revenue</th>
                                        <th>Salary</th>
                                        <th>Commission</th>
                                        <th>Expenses</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {datae.map((item, index) => (
                                        <tr key={index}>
                                          <td className="lef">{item.month}</td>
                                          <td>{item.revenue}</td>
                                          <td>{item.salary}</td>
                                          <td>{item.commission}</td>
                                          <td className="ref">{item.expenses}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                              <div className="d-md-none aco-mobile">
                                {datae.map((item, index) => (
                                  <Card key={index} className="mb-3">
                                    <h2>{item.month}</h2>
                                      <div className="d-flex justify-content-between two">
                                        <div>
                                          <h3>Revenue</h3>
                                          <h4>{item.revenue}</h4>
                                        </div>
                                        <div>
                                          <h3>Salary</h3>
                                          <h4>{item.salary}</h4>
                                        </div>
                                      </div>
                                      <div className="d-flex justify-content-between two">
                                        <div>
                                          <h3>Commission</h3>
                                          <h4>{item.commission}</h4>
                                        </div>
                                        <div>
                                          <h3>Expense</h3>
                                          <h4>{item.expenses}</h4>
                                        </div>
                                      </div>
                                  </Card>
                                ))}
                              </div>
                            </Card>
                          </div>

                          <div className="col-md-6 col-xl-5 col-xxl-4 last-ch">
                            <div className="card h-100">
                              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
                                <h2>Accounting Reports</h2>
                                <div className="position-relative d-none d-md-block">
                                  <select
                                    className="ju-dr"
                                    value={selected}
                                    onChange={(e) => setSelected(e.target.value)}
                                    style={{
                                      appearance: 'none',
                                      WebkitAppearance: 'none',
                                      MozAppearance: 'none',
                                    }}
                                  >
                                    {Object.keys(chartData).map((option) => (
                                      <option key={option}>{option}</option>
                                    ))}
                                  </select>

                                  <img
                                    src={process.env.REACT_APP_BASE_URL + 'assests/images/Vectorff.png'}
                                    alt="dropdown"
                                    style={{
                                      position: 'absolute',
                                      right: '7px',
                                      top: '50%',
                                      transform: 'translateY(-50%)',
                                      width: '16px',
                                      height: '16px',
                                      pointerEvents: 'none',
                                    }}
                                  />
                                </div>
                              </div>

                              <ResponsiveContainer width="100%" height={250}>
                                <BarChart
                                  data={chartData[selected]}
                                  barCategoryGap={40}
                                  barGap={50}
                                  barSize={28}
                                  margin={{ bottom: 10 }} 
                                >
                                  <XAxis hide />
                                  <YAxis
                                    domain={[0, 30000]}
                                    ticks={[0, 10000, 20000, 30000]}
                                    tickFormatter={(value) =>
                                      value === 0 ? '0' : `${value / 1000}K`
                                    }
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{
                                      style: {
                                        fontFamily: '"Inter", sans-serif',
                                        fontWeight: 400,
                                        fontSize: '12px',
                                        lineHeight: '18px',
                                        fill: 'var(--black-40, #1C1C1C66)',
                                      },
                                    }}
                                  />
                                  <Tooltip
                                    formatter={(value) => `$${value}`}
                                    cursor={{ fill: "transparent" }}
                                  />
                                  <Bar dataKey="Salary" fill={COLORSSS.Salary} radius={[8, 8, 8, 8]} />
                                  <Bar dataKey="Revenue" fill={COLORSSS.Revenue} radius={[8, 8, 8, 8]} />
                                  <Bar dataKey="Commission" fill={COLORSSS.Commission} radius={[8, 8, 8, 8]} />
                                  <Bar dataKey="Expenses" fill={COLORSSS.Expenses} radius={[8, 8, 8, 8]} />
                                </BarChart>
                              </ResponsiveContainer>

                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop: "8px",
                                  fontSize: "13px",
                                  fontWeight: 600,
                                  color: "#64748B",
                                  fontFamily: '"Inter", sans-serif',
                                }}
                              >
                                {chartData[selected][0].name}
                              </div>

                              {/* ✅ Custom Legend below the chart */}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginTop: "10px",
                                  flexWrap: "wrap",
                                  padding: "0 10px",
                                }}
                              >
                                {items.map((item) => (
                                  <div
                                    key={item.name}
                                    style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "10px", justifyContent: "center" }}
                                  >
                                    <div
                                      style={{
                                        width: "10px",
                                        height: "10px",
                                        backgroundColor: item.color,
                                        borderRadius: "4px",
                                      }}
                                    />
                                    <span className="seki">{item.name}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && (
       <div className="loadingClass">
        <img src={loader} alt="loader"/>
      </div>
       )}  
    </>
  );
};

export default Overview;